export default "__VITE_ASSET__BJiz3B3S__"